import { Tabs } from "antd";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import MainPagetitle from "../../../layouts/MainPagetitle";
import AgentApplication from "./agentApplication/agentApplication";
import Agentslist from "./agentslist/agentslist";
const Agents = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const isConnector =
    props?.$store?.user?.role === _enum.ROUTE_PERSONAS.connector;
  const isPanVerified = props.$store?.user?.is_pan_code_verified;
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;
  const is_agreement_signed = props.$store?.user?.is_agreement_signed;

  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey = searchParams.get("tab") || "agents";

  const tabItems = [
    { key: "agents", label: "Agents List", type: "custom", status: "AGENTS" },
    { key: "pending", label: "Pending Applications", status: "PENDING" },
    { key: "assigned", label: "Assigned", status: "ASSIGNED" },
    { key: "disbursed", label: "Disbursed", status: "DISBURSED" },
    { key: "rejected", label: "Rejected", status: "REJECTED" },
  ];

  const onChange = (key) => {
    setSearchParams({ tab: key });
  };

  useEffect(() => {
    if (isConnector) {
      if (!isPanVerified || !isAadharVerified || !is_agreement_signed) {
        swal2
          .fire({
            title: "Account Verification Pending",
            text: "Please complete your profile",
            icon: "info",
            iconColor: "#234C9B",
          })
          .then((result) => {
            if (result.isConfirmed) {
              props.navigate("/app/myprofile");
            }
          });
      }
    }
  }, []);
  return (
    <>
      <MainPagetitle
        mainTitle="Agents"
        pageIcon={imagepaths.SingleUserAgentIconActive}
      />
      <div className="container-fluid">
        <div className="header_box">{/* <MyEarningCards /> */}</div>
        <Card name="custom-tab" className="dz-card min-h-[600px]">
          <Card.Body>
            <Tabs
              activeKey={activeKey}
              onChange={onChange}
              destroyInactiveTabPane={false}
              items={tabItems.map((tab) => ({
                key: tab.key,
                label: tab.label,
                children:
                  tab.type === "custom" ? (
                    <Agentslist
                      {...props}
                      status={tab.status}
                      activeKey={activeKey}
                    />
                  ) : (
                    <AgentApplication
                      {...props}
                      status={tab.status}
                      activeKey={activeKey}
                    />
                  ),
              }))}
            />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default constore(Agents);
